import { marked } from 'marked';
import DOMPurify from 'dompurify';

marked.setOptions({
	gfm: true,
	breaks: true,
});

const ALLOWED_TAGS = [
	'p', 'br', 'strong', 'em', 'b', 'i', 'u', 's', 'del', 'mark',
	'ul', 'ol', 'li',
	'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
	'blockquote',
	'code', 'pre',
	'table', 'thead', 'tbody', 'tr', 'th', 'td',
	'a', 'hr', 'span', 'div',
];

const ALLOWED_ATTR = ['href', 'target', 'rel', 'class'];

/**
 * Envolve cada <table>...</table> num wrapper rolável.
 * Operamos sobre o HTML JÁ saneado, gerado pelo `marked`, então não há
 * risco de quebra de tag arbitrária do usuário.
 */
function wrapTables(html) {
	return html
		.replace(/<table(\s|>)/g, '<div class="md-table-wrap"><table$1')
		.replace(/<\/table>/g, '</table></div>');
}

export function renderMarkdown(text) {
	if (!text) return '';

	const html = marked.parse(String(text));
	const safe = DOMPurify.sanitize(html, {
		ALLOWED_TAGS,
		ALLOWED_ATTR,
		ADD_ATTR: ['target', 'rel'],
	});
	return wrapTables(safe);
}

export default renderMarkdown;
